var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrowseCoursesMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1667 13.5415C6.02409 13.7622 7.75321 14.6014 9.07582 15.924C10.3984 17.2467 11.2376 18.9758 11.4584 20.8332C12.3791 20.3023 13.1493 19.5455 13.6961 18.6341C14.2429 17.7228 14.5483 16.6871 14.5834 15.6248C16.3324 15.0095 17.8598 13.8894 18.9723 12.4061C20.0848 10.9228 20.7324 9.1429 20.8334 7.2915C20.8334 6.4627 20.5041 5.66785 19.9181 5.0818C19.332 4.49574 18.5372 4.1665 17.7084 4.1665C15.857 4.26745 14.0771 4.91511 12.5938 6.0276C11.1105 7.14009 9.99033 8.66743 9.37504 10.4165C8.31281 10.4516 7.27707 10.757 6.36573 11.3038C5.45438 11.8506 4.69753 12.6208 4.1667 13.5415",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29167 14.583C6.20753 15.1951 5.33089 16.1169 4.77412 17.2305C4.21735 18.344 4.00583 19.5985 4.16667 20.833C5.40121 20.9938 6.65565 20.7823 7.76919 20.2256C8.88273 19.6688 9.80462 18.7921 10.4167 17.708",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 10.4163C16.2003 10.4163 16.6667 9.94997 16.6667 9.37467C16.6667 8.79938 16.2003 8.33301 15.625 8.33301C15.0497 8.33301 14.5833 8.79938 14.5833 9.37467C14.5833 9.94997 15.0497 10.4163 15.625 10.4163Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseCoursesMenuIcon);
export default __webpack_public_path__ + "static/media/browseCourses-menu-icon.bf38ac62c3b75ab7a69574dd1a47880f.svg";
export { ForwardRef as ReactComponent };